import RPTilt, { ReactParallaxTiltProps } from 'react-parallax-tilt';

export function Tilt(props: ReactParallaxTiltProps) {
  return (
    <RPTilt
      glareEnable
      glareMaxOpacity={0.3}
      glareColor="#ffffff"
      glarePosition="all"
      glareBorderRadius="8px"
      tiltMaxAngleX={10}
      tiltMaxAngleY={10}
      {...props}
    />
  );
}
